import { X } from 'lucide-react'

import { ValueProvenance } from '@/components/fields/ValueProvenance'
import type { LoanFieldLineageField } from '@/pages/pipeline-intelligence/types'

/**
 * Where an Overview figure no document states comes from: a Derived value's
 * formula and inputs, a Suggested value's basis, who Confirmed a value and
 * when. Opening the document viewer for one of these found no file (the
 * lineage source reads "derived: NOI / loan") and said "The recorded source
 * file is unavailable", as though a document had been lost.
 */
export function FieldProvenancePanel({
  label,
  value,
  field,
  onClose,
  onOpenSource,
}: {
  label: string
  value: string
  field: LoanFieldLineageField | null | undefined
  onClose: () => void
  /** A document the provenance names (a stated input), opened in the viewer. */
  onOpenSource?: () => void
}) {
  return (
    <aside
      data-testid="field-provenance-panel"
      className="flex h-full w-[248px] shrink-0 flex-col border-l border-stone-800/80 bg-[#080808]"
    >
      <header className="flex items-start justify-between border-b border-stone-800/80 px-3 py-2">
        <div className="min-w-0">
          <div className="font-mono text-[8px] font-semibold uppercase tracking-[0.16em] text-amber-300/90">Where this figure comes from</div>
          <div className="mt-0.5 truncate font-mono text-[13px] font-medium text-stone-100">{`${label} ${value}`}</div>
        </div>
        <button type="button" onClick={onClose} aria-label="Close" className="rounded p-0.5 text-stone-600 hover:text-stone-300">
          <X size={14} />
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-auto px-3 py-2">
        {field ? (
          <ValueProvenance field={field} onOpenSource={onOpenSource ? () => onOpenSource() : undefined} />
        ) : (
          <p className="text-[10px] text-stone-500">No lineage is recorded for this figure.</p>
        )}
      </div>
    </aside>
  )
}
